export const EASYLEASE = {
  name: 'EasyLease',
  legalName: 'EasyLease Vehicle Rental',
  handle: 'easylease',
  logo: 'https://cdn.magicpatterns.com/uploads/4dHNpFvrhGx8T4VSYNGooH/Easylease_logo.png',
  tagline:
    'Find, compare and rent the right vehicle with AI — from sedans and SUVs to luxury cars, vans and commercial fleets.',
  positioning:
    'Your trusted UAE mobility partner for short-term rentals, long-term leasing and vehicle delivery.',
}
export type CategoryIconName =
  | 'all'
  | 'sedan'
  | 'suv'
  | 'luxury'
  | 'van'
  | 'pickup'
  | 'bus'
  | 'electric'
  | 'monthly'
  | 'daily'
export interface VehicleCategory {
  /** Short label for the ribbon so ten fit without scrolling. */
  label: string
  /** Full name used in Browse by Category. */
  name: string
  icon: CategoryIconName
  /** Question handed to the assistant when chosen. */
  prompt: string
}
export const vehicleCategories: VehicleCategory[] = [
  {
    label: 'All',
    name: 'All Vehicles',
    icon: 'all',
    prompt: 'Show me everything available in your fleet',
  },
  {
    label: 'Sedans',
    name: 'Sedans',
    icon: 'sedan',
    prompt: 'Show me available sedans',
  },
  {
    label: 'SUVs',
    name: 'SUVs & 4WDs',
    icon: 'suv',
    prompt: 'Show me available SUVs & 4WDs',
  },
  {
    label: 'Luxury',
    name: 'Luxury',
    icon: 'luxury',
    prompt: 'Show me luxury cars available today',
  },
  {
    label: 'Vans',
    name: 'Vans',
    icon: 'van',
    prompt: 'I need a van for my business',
  },
  {
    label: 'Pickups',
    name: 'Pickups',
    icon: 'pickup',
    prompt: 'Show me pickups for site work',
  },
  {
    label: 'Buses',
    name: 'Buses',
    icon: 'bus',
    prompt: 'I need a bus for staff transport',
  },
  {
    label: 'Electric',
    name: 'Electric & Hybrid',
    icon: 'electric',
    prompt: 'Show me electric or hybrid options',
  },
  {
    label: 'Monthly',
    name: 'Monthly Lease',
    icon: 'monthly',
    prompt: 'What are your monthly lease rates?',
  },
  {
    label: 'Daily',
    name: 'Daily Rental',
    icon: 'daily',
    prompt: 'What are your daily rental rates?',
  },
]
export interface Vehicle {
  id: string
  name: string
  category: string
  /** Short spec line, e.g. "SUV · Automatic · 7 Seats". */
  details: string
  monthly: string
  daily: string
  image: string
  badge?: string
}
export const featuredVehicles: Vehicle[] = [
  {
    id: 'prado',
    name: 'Toyota Prado 2026',
    category: 'SUVs & 4WDs',
    details: 'SUV · Automatic · 7 Seats',
    monthly: 'AED 4,500 / month',
    daily: 'AED 350 / day',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/daa13e0d-60d6-4ee9-907b-f972b4ca1779.jpg',
    badge: 'Most requested',
  },
  {
    id: 'landcruiser',
    name: 'Toyota Land Cruiser 2025',
    category: 'Luxury',
    details: 'Full-size SUV · Automatic · 7 Seats',
    monthly: 'AED 7,900 / month',
    daily: 'AED 650 / day',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/55dfa6e9-1811-4a09-8277-5a2c549eeaba.jpg',
    badge: 'Chauffeur option',
  },
  {
    id: 'hiace',
    name: 'Toyota Hiace 2025',
    category: 'Vans',
    details: 'Passenger Van · Manual · 13 Seats',
    monthly: 'AED 3,400 / month',
    daily: 'AED 280 / day',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4c8cb0ff-84ec-480e-befb-d525a66da3c5.jpg',
    badge: 'Corporate fleet',
  },
  {
    id: 'camry',
    name: 'Toyota Camry 2025',
    category: 'Sedans',
    details: 'Sedan · Automatic · 5 Seats',
    monthly: 'AED 2,200 / month',
    daily: 'AED 180 / day',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/5b0c5d36-1cc1-4bfa-801d-39f1d228c1bd.jpg',
    badge: 'Best value',
  },
]
export const evVehicleImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/e4fecafe-fc13-470b-9862-04db2d0407d0.jpg'

/**
 * The wider fleet a merchant can pick from when they curate the Featured row
 * themselves. The first four are the defaults.
 */
export const fleetVehicles: Vehicle[] = [
  ...featuredVehicles,
  {
    id: 'corolla',
    name: 'Toyota Corolla 2025',
    category: 'Sedans',
    details: 'Sedan · Automatic · 5 Seats',
    monthly: 'AED 1,750 / month',
    daily: 'AED 140 / day',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/5b0c5d36-1cc1-4bfa-801d-39f1d228c1bd.jpg',
  },
  {
    id: 'patrol',
    name: 'Nissan Patrol 2025',
    category: 'Luxury',
    details: 'Full-size SUV · Automatic · 7 Seats',
    monthly: 'AED 8,400 / month',
    daily: 'AED 700 / day',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/55dfa6e9-1811-4a09-8277-5a2c549eeaba.jpg',
  },
  {
    id: 'hilux',
    name: 'Toyota Hilux 2025',
    category: 'Pickups',
    details: 'Double Cab · Manual · 5 Seats',
    monthly: 'AED 2,900 / month',
    daily: 'AED 240 / day',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4c8cb0ff-84ec-480e-befb-d525a66da3c5.jpg',
  },
  {
    id: 'coaster',
    name: 'Toyota Coaster 2024',
    category: 'Buses',
    details: 'Minibus · Manual · 22 Seats',
    monthly: 'AED 5,600 / month',
    daily: 'AED 480 / day',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4c8cb0ff-84ec-480e-befb-d525a66da3c5.jpg',
  },
  {
    id: 'ev-sedan',
    name: 'BYD Seal 2025',
    category: 'Electric & Hybrid',
    details: 'Electric Sedan · Automatic · 5 Seats',
    monthly: 'AED 3,100 / month',
    daily: 'AED 260 / day',
    image: evVehicleImage,
  },
  {
    id: 'ev-suv',
    name: 'Tesla Model Y 2025',
    category: 'Electric & Hybrid',
    details: 'Electric SUV · Automatic · 5 Seats',
    monthly: 'AED 4,900 / month',
    daily: 'AED 400 / day',
    image: evVehicleImage,
  },
]
export const suggestedPrompts = [
  'Show me available SUVs',
  'What are your monthly rental rates?',
  'I need airport pickup and delivery',
  'Show me luxury cars available today',
  'Compare Prado vs Land Cruiser',
  'I need a van for my business',
  'Show me electric or hybrid options',
  'I need a 7-seater for one month',
]
export type BenefitIconName =
  | 'calendar'
  | 'delivery'
  | 'support'
  | 'coverage'
  | 'corporate'
export const benefits: {
  icon: BenefitIconName
  label: string
  detail: string
}[] = [
  {
    icon: 'calendar',
    label: 'Short & Long Term',
    detail: 'Daily rentals through multi-year leases',
  },
  {
    icon: 'delivery',
    label: 'Delivery & Collection',
    detail: 'Door-to-door handover across the UAE',
  },
  {
    icon: 'support',
    label: '24/7 Roadside Support',
    detail: 'Replacement vehicle within hours',
  },
  {
    icon: 'coverage',
    label: 'Dubai & Abu Dhabi',
    detail: 'Branches and service centres in both',
  },
  {
    icon: 'corporate',
    label: 'Corporate & Individual',
    detail: 'Scalable fleets with one account manager',
  },
]
